import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../@cultureamp/frontend-svg-util/browser-sprite.js";
var symbol = new SpriteSymbol({
  "id": "ca-icon-close.icon",
  "use": "ca-icon-close.icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"ca-icon-close.icon\"><defs><path id=\"ca-icon-close.icon_a\" d=\"M14.654 4.167 10 8.82 5.346 4.167l-1.18 1.18L8.823 10l-4.655 4.655 1.179 1.178L10 11.18l4.654 4.654 1.18-1.178L11.18 10l4.655-4.653z\" /></defs><use fill=\"currentColor\" xlink:href=\"#ca-icon-close.icon_a\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol